import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsReplDotItComponent } from './simple-icons-repl-dot-it.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsReplDotItComponent ],
    exports:      [ SimpleIconsReplDotItComponent ],
    bootstrap:    []
})
export class SimpleIconsReplDotItModule {}
